import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { WorkOrderDetails } from '../types/WorkOrderDetails';

export const useGetWorkOrder = (workOrderID: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['work-order', workOrderID],
        queryFn: async () => await apiClient.get('work-order/dealer-details',
            {
                params: {
                    workOrderID: workOrderID
                }
            }) as WorkOrderDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
